<template>
  <section id="news" class="section_container">
    <v-container>
      <default-home-section-title :title="titleSection" />
      <v-row>
        <v-col cols="12" align="start">
          <v-card color="white" elevation="0">
            <v-card-text class="text-left">
              <p
                class="text-h4 font-weight-medium"
                style="color: black; text-indent: 1cm;"
                align="justify"
              >
                {{ textFirst }}
              </p>
              <p
                class="text-h4 font-weight-medium mt-6"
                style="color: black; text-indent: 1cm;"
                align="justify"
              >
                {{ textSecond }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "DefaultHomeSectionNews",
  components: {
    DefaultHomeSectionTitle: () => import("@/views/Home/HomeSectionTitle.vue"),
  },
  data() {
    return {
      titleSection: "Новости",
      textFirst:
        "В СООТВЕТСТВИИ С ПРИКАЗОМ МИНИСТРА ЭНЕРГЕТИКИ РЕСПУБЛИКИ КАЗАХСТАН ОТ 4 НОЯБРЯ 2019 ГОДА № 357 «ОБ УТВЕРЖДЕНИИ ПЕРЕЧНЯ И СРОКОВ ОСНАЩЕНИЯ ПРОИЗВОДСТВЕННЫХ ОБЪЕКТОВ, ПОДЛЕЖАЩИХ ОСНАЩЕНИЮ ПРИБОРАМИ УЧЕТА СЫРОЙ НЕФТИ, ГАЗОВОГО КОНДЕНСАТА, СЫРОГО ГАЗА И ПРОДУКТОВ ЕГО ПЕРЕРАБОТКИ (ТОВАРНОГО ГАЗА)», ТРЕБОВАНИЯ К ИНФОРМАЦИОННОМУ ВЗАИМОДЕЙСТВИЮ «ИНФОРМАЦИОННОЙ СИСТЕМЫ УЧЕТА СЫРОЙ НЕФТИ И ГАЗОВОГО КОНДЕНСАТА, СЫРОГО ГАЗА И ПРОДУКТОВ ЕГО ПЕРЕРАБОТКИ (ТОВАРНОГО ГАЗА)» С «ИНФОРМАЦИОННОЙ СИСТЕМОЙ СУБЪЕКТА» НАХОДЯТСЯ В РАЗДЕЛЕ «ДОКУМЕНТАЦИЯ».",
      textSecond:
        "В СЛУЧАЕ ВОЗНИКНОВЕНИЯ ДОПОЛНИТЕЛЬНЫХ ВОПРОСОВ В РАБОТЕ ИСУНГ ПРОСИМ ОБРАТИТЬСЯ В ТЕХНИЧЕСКУЮ ПОДДЕРЖКУ ПО: E-MAIL: ISUNG@SACTEK.KZ ИЛИ ЖЕ ПО ТЕЛЕФОНУ: +7 700 2000327, +7 7172 267474.",
    };
  },
};
</script>

<style lang="scss" scoped>
.section_container {
  background-color: #fff;
  width: 70%;
  margin: 0 auto;
}
</style>
